var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppView',[_c('p',[_c('img',{attrs:{"src":require("@/assets/logo_nsfw.png"),"alt":"algogems"}}),_vm._v("Sorry, we are currently under maintenance. Algogems.io should be back online soon. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }